import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Scale, ClipboardList, UserCheck, AlertTriangle, CreditCard, ShieldCheck, Mail } from 'lucide-react';
import './TermsPage.css';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-standalone">
      {/* Navigation */}
      {/* <nav className="terms-nav">
        <button onClick={() => navigate('/')} className="back-btn-terms">
          <ArrowLeft size={20} /> Back to Home
        </button>
        <div className="brand-name">🏥 The Doctor At Home</div>
      </nav> */}

      <div className="terms-wrapper">
        <header className="terms-hero">
          <Scale size={50} className="terms-main-icon" />
          <h1>Terms & Conditions</h1>
          <p className="last-update">Version 2.1 | Effective: February 2026</p>
        </header>

        {/* --- Emergency Disclaimer Section --- */}
        <section className="terms-alert-box">
          <AlertTriangle className="alert-icon" size={28} />
          <div>
            <h4>Immediate Emergency Notice</h4>
            <p>
              "The Doctor At Home" and the Infowave platform are NOT for medical emergencies. 
              In case of a life-threatening situation, contact local emergency services immediately. 
              We do not provide chronic patient care or 24/7 emergency monitoring.
            </p>
          </div>
        </section>

        <div className="terms-content-container">
          
          {/* 1. Acceptance */}
          <section className="terms-section">
            <h3>1. Acceptance of Terms</h3>
            <p>
              By downloading, installing, or using "The Doctor At Home" App, you agree to be bound by these Terms. 
              These Terms constitute a legal agreement between you (the Patient/User) and Infowave. 
              If you are under 18, you must use this service only under the supervision of a parent or guardian.
            </p>
          </section>

          {/* 2. Services Description */}
          <section className="terms-section">
            <h3>2. Description of Services</h3>
            <p>Our platform facilitates the following healthcare services:</p>
            <ul className="terms-list">
              <li>Connecting patients with certified Doctors for home visits.</li>
              <li>Booking and scheduling for Nursing care and Physiotherapy.</li>
              <li>In-app consultation history and digital prescription storage.</li>
              <li>Facilitation of home-based pathology (blood/urine) test collection.</li>
            </ul>
            <div className="terms-note">
              <strong>Important:</strong> The Company (Infowave) is a technology aggregator. Doctors are independent contractors. 
              The Company is not liable for the clinical outcomes or medical advice provided by independent practitioners.
            </div>
          </section>

          {/* 3. Patient Responsibilities */}
          <section className="terms-section">
            <h3>3. Patient Responsibilities & Conduct</h3>
            <div className="check-grid">
              <div className="check-item"><ShieldCheck size={18} /> Provide 100% accurate medical history and current symptoms.</div>
              <div className="check-item"><ShieldCheck size={18} /> Ensure a safe environment for the doctor during the home visit.</div>
              <div className="check-item"><ShieldCheck size={18} /> Comply with the prescribed treatment and follow-up instructions.</div>
              <div className="check-item"><ShieldCheck size={18} /> Zero tolerance for harassment or misconduct towards visiting staff.</div>
            </div>
          </section>

          {/* 4. Payment & Refund Policy */}
          <section className="terms-section">
            <h3>4. Fees, Payments & Refunds</h3>
            <div className="payment-table-wrapper">
              <table className="terms-table">
                <thead>
                  <tr>
                    <th>Service Type</th>
                    <th>Payment Mode</th>
                    <th>Refund Eligibility</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Doctor Home Visit</td>
                    <td>Online / Cash</td>
                    <td>Full refund if cancelled 2 hrs prior</td>
                  </tr>
                  <tr>
                    <td>Nursing/Physio</td>
                    <td>Prepaid / Partial</td>
                    <td>Pro-rata basis for sessions</td>
                  </tr>
                  <tr>
                    <td>Lab Tests</td>
                    <td>Online</td>
                    <td>Non-refundable once sample is collected</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="sub-text">
              *Refunds for failed transactions are initiated within 24 hours and reflect in your account within 7-10 working days.
            </p>
          </section>

          {/* 5. Limitation of Liability */}
          <section className="terms-section">
            <h3>5. Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by law, Infowave and its affiliates shall not be liable for any indirect, 
              incidental, or consequential damages resulting from the use of the app or the services provided by 
              independent doctors. Our total liability is limited to the amount paid by you for the specific service in question.
            </p>
          </section>

          {/* 6. Contact & Support (Email Working) */}
          <section className="terms-section contact-highlight">
            <h3>6. Contact Information & Support</h3>
            <p>For disputes, feedback, or technical support, please reach out to us:</p>
            <div className="contact-methods">
              <a href="mailto:thedoctorathome2@gmail.com" className="contact-card">
                <Mail className="contact-icon" />
                <div>
                  <strong>Email Support</strong>
                  <p>thedoctorathome2@gmail.com</p>
                </div>
              </a>
              <div className="contact-card">
                <ClipboardList className="contact-icon" />
                <div>
                  <strong>App Support</strong>
                  <p>Available in "Help" Section</p>
                </div>
              </div>
            </div>
          </section>

        </div>

        <footer className="terms-footer-simple">
            <p>By clicking "Accept" or using the App, you agree to these Terms and Conditions.</p>
            <p className="copyright">© 2026 Infowave | The Doctor At Home. All Rights Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default TermsPage;